function InventoryData() {
    "use strict";

    this.TargetId = -1;

    // Devices
    this.DevicesClean = null;
    this.DevicesDirty = null;
    this.DevicesListViewPaginated = null;
    this.DevicesSelectedIds = [];
    this.DevicesSelectedOverlap = [];

    // Device Clusters
    this.DeviceClustersClean = null;
    this.DeviceClustersDirty = null;
    this.DeviceClustersPaginated = null;

    this.DeviceClustersSelected = -1;
    this.DeviceClusterReadsRemaining = 0;
    this.DeviceClustersAssignedDeviceList = null;
    this.DeviceClustersAssignedEnrolleeList = null;
    this.DeviceClustersAssignedDeviceTempList = null;
    this.DeviceClustersAssignedEnrolleeTempList = null;

    this.DeviceClustersLastSelectedId = null;
    this.DeviceClustersLastSelectedDeviceList = null;
    this.DeviceClustersLastSelectedEnrolleeList = null;
    this.DistancePoints = [];
    this.DistanceToolActive = false;

    //Tile Analysis
    this.InventoryTileClean = null;
    this.InventoryTileDirty = null;
    this.InventoryTileSelectedIds = null;
    this.InventoryTileTiles = [];

    this.KnownLocationEditData = null;
    this.EditShape = null;

    //battery history
    this.BatteryDate = null;
    this.BatteryDateFormat = 'MM/DD/YYYY HH:mm';
}
if (typeof exports !== 'undefined') {
    module.exports = InventoryData;
}